
import { cn } from "@/lib/utils";
import { SeshBalance } from "@/components/sesh/SeshBalance";
import { useSidebar } from "@/components/ui/sidebar";
import { useIsMobile } from "@/hooks/use-mobile";
import { Logo } from "@/components/ui/logo";

const SidebarHeader = ({ className }: { className?: string }) => {
  const { state } = useSidebar();
  const isMobile = useIsMobile();
  const isCollapsed = state === 'collapsed';

  return (
    <div className={cn("flex flex-col gap-4 py-4", className)}>
      <div className={cn(
        "flex items-center",
        isCollapsed ? "justify-center px-2" : "justify-between px-6"
      )}>
        <div className="flex items-center">
          <Logo
            size={isCollapsed ? "sm" : "md"}
            variant="default"
            className={cn(isCollapsed && "mx-auto")}
            hideText={isCollapsed}
          />
        </div>

      </div>
    </div>
  );
};

export default SidebarHeader;
